<template>
<div>
     <v-data-table :search="search" v-if="!isLoading" :single-select="singleSelect" v-model="selected" show-select :footer-props="{
            showFirstLastPage: true,
            firstIcon: 'mdi-arrow-collapse-left',
            lastIcon: 'mdi-arrow-collapse-right',
            prevIcon: 'mdi-minus',
            nextIcon: 'mdi-plus',
          }" :headers="headers" class="elevation-1 mt-0 px-5" :items="idPage == 1 ? message : message2" :height="inerHeight">

          <template v-slot:top>

               <v-toolbar flat color="">
                    <v-toolbar-title style="font-size: 25px">{{ idPage == 1 ? $t('msgRecive') : $t('msgEnvoye') + ':'}}</v-toolbar-title>
                    <v-spacer></v-spacer>

                    <v-menu v-model="menu2" :close-on-content-click="false" :nudge-right="10" transition="scale-transition" offset-y min-width="240px">
                         <template v-slot:activator="{ on }">
                              <v-text-field class="ma-2" @click:clear="clirtext" dense hide-details outlined v-model="dateRangeText" :label="$t('dateDF')" clearable readonly v-on="on"></v-text-field>
                         </template>
                         <v-date-picker v-model="filters.created_at" range></v-date-picker>
                    </v-menu>

                    <v-tooltip bottom>
                         <template v-slot:activator="{ on }">
                              <v-btn @click="deleteMulti" v-on="on" class="ma-2" hide-details tile color="red">
                                   <v-icon color="white" size="30">mdi-delete-sweep</v-icon>
                              </v-btn>
                         </template>
                         <span>{{ $t('deleteMulti') }}</span>
                    </v-tooltip>

               </v-toolbar>
          </template>

          <template v-slot:item.isShow="{ item }">
               <v-chip color="green lighten-0" dark v-if="item.isShow == 1">
                    <v-icon>mdi-eye</v-icon>
               </v-chip>
               <v-chip color="red lighten-1" dark v-else>
                    <v-icon>mdi-eye-off</v-icon>
               </v-chip>
          </template>

          <template v-slot:item.message="{ item }">
               <span dark color="grey lighten-1">{{ item.message.substring(0,12)  }}...</span>
          </template>

          <template v-slot:item.action="{ item }">

               <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                         <v-btn v-on="on" icon color="green" @click="idPage == 1 ? updateResponse(item,1) : updateResponse(item,2)">
                              <v-icon size="25"> {{idPage == 1 ?  'mdi-message-reply-text' : 'mdi-expand-all' }} </v-icon>
                         </v-btn>
                    </template>
                    <span>{{ idPage == 1 ?  $t('response') : $t('details') }}</span>
               </v-tooltip>

               <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                         <v-btn v-on="on" icon color="red" @click="removeItem(item)">
                              <v-icon size=30>mdi-delete-outline </v-icon>
                         </v-btn>
                    </template>
                    <span>{{ $t('supprimer') }}</span>
               </v-tooltip>

          </template>
     </v-data-table>

     <v-dialog v-model="dialog2" persistent max-width="900">
          <v-card>
               <v-card-title class="headline py-1">{{ $t('response') + ' :' }}
                    <v-spacer></v-spacer>
                    <v-tooltip bottom>
                         <template v-slot:activator="{ on }">
                              <v-btn v-on="on" color="error" outlined icon @click="close" class="mt-1 mr-2">
                                   <v-icon>mdi-close</v-icon>
                              </v-btn>
                         </template>
                         <span>{{ $t('close') }}</span>
                    </v-tooltip>
               </v-card-title>
               <v-card-text>
                    <v-row>
                         <v-col cols="12" md="12">
                              <v-spacer></v-spacer>
                              <v-card>
                                   <v-card-text>
                                        <v-row>
                                             <v-col cols="12" md="12">
                                                  <v-text-field readonly outlined hide-details dense v-model="form.email" :label="$t('email')" required>
                                                  </v-text-field>
                                             </v-col>
                                             <v-col cols="12" md="12">
                                                  <v-text-field clearable outlined hide-details dense v-model="form.sujet" :label="$t('sujet')" required>
                                                  </v-text-field>

                                             </v-col>
                                             <v-col cols="12" md="6">
                                                  <yimo-vue-editor v-model="form.reponse"></yimo-vue-editor>
                                                  <!-- <v-textarea  clearable outlined hide-details dense  v-model="form.text"></v-textarea> -->
                                             </v-col>
                                             <v-col cols="12" md="6">
                                                  <v-textarea :label="$t('msg')" readonly rows="9" outlined hide-details dense v-model="form.message"></v-textarea>
                                             </v-col>
                                        </v-row>

                                   </v-card-text>
                              </v-card>
                         </v-col>

                    </v-row>
               </v-card-text>
               <v-card-actions class=" py-0">
                    <v-spacer></v-spacer>

                    <v-icon :disabled="loading" class="btnIcon mx-4" color="green" size="40" @click="sendEmail">mdi-send</v-icon>

               </v-card-actions>
          </v-card>
     </v-dialog>

     <v-dialog v-model="dialog3" persistent max-width="900">
          <v-card>
               <v-card-title class="headline py-1 pt-3">{{ $t('details') + ' :' }}
                    <v-spacer></v-spacer>
                    <v-tooltip bottom>
                         <template v-slot:activator="{ on }">
                              <v-btn v-on="on" color="error" outlined icon @click="close" class="mt-1 mr-2">
                                   <v-icon>mdi-close</v-icon>
                              </v-btn>
                         </template>
                         <span>{{ $t('close') }}</span>
                    </v-tooltip>
               </v-card-title>
               <v-card-text>
                    <v-row>
                         <v-col cols="12" md="12">
                              <v-spacer></v-spacer>
                              <v-card>
                                   <v-card-text>
                                        <v-row class="py-0">
                                             <v-col cols="12" lg="6" md="6" sm="12">
                                                  <v-text-field readonly outlined hide-details dense v-model="details.nom" :label="$t('nom')" required>
                                                  </v-text-field>
                                             </v-col>
                                             <v-col cols="12" lg="6" md="6" sm="12">
                                                  <v-text-field readonly outlined hide-details dense v-model="details.email" :label="$t('email')" required>
                                                  </v-text-field>
                                             </v-col>
                                             <v-col cols="12" lg="6" md="6" sm="6">
                                                  <v-text-field readonly outlined hide-details dense v-model="details.created_at" :label="$t('dateEnv')" required>
                                                  </v-text-field>
                                             </v-col>
                                             <v-col cols="12" lg="6" md="6" sm="6">
                                                  <v-text-field readonly outlined hide-details dense v-model="details.updated_at" :label="$t('dateReps')" required>
                                                  </v-text-field>
                                             </v-col>
                                             <v-col cols="12" md="6" lg="6" sm="12">
                                                  <v-textarea :label="$t('msg')" class="px-0" readonly rows="9" outlined hide-details dense v-model="details.message"></v-textarea>
                                             </v-col>
                                             <v-col cols="12" md="6" lg="6" sm="12">
                                                  <v-textarea :label="$t('response')" background-color="#ddd" readonly rows="9" outlined hide-details dense v-model="details.reponse"></v-textarea>
                                             </v-col>
                                        </v-row>

                                   </v-card-text>
                              </v-card>
                         </v-col>

                    </v-row>
               </v-card-text>
          </v-card>
     </v-dialog>

</div>
</template>

<script>
import YimoVueEditor from 'yimo-vue-editor'
export default {
     components: {
          YimoVueEditor,
     },
     data() {
          return {
               details: {
                    email: '',
                    nom: '',
                    message: '',
                    reponse: '',
                    created_at: '',
                    updated_at: '',
               },
               idPage: 1,
               loading: false,
               menu2: false,
               dialog2: false,
               dialog3: false,
               inerHeight: window.innerHeight - 260,
               selected: [],
               filters: {
                    isShow: '',
                    created_at: [],
               },
               search: '',
               singleSelect: false,
               headers: [{
                         text: localStorage.getItem('lang') == 'fr' ? 'Nom' : 'الإسم',
                         value: 'nom',
                         align: 'center',
                         sortable: false
                    },
                    {
                         text: localStorage.getItem('lang') == 'fr' ? 'Email' : 'البريد الإلكلتروني',
                         value: 'email',
                         align: 'center',
                         sortable: false
                    },
                    {
                         text: localStorage.getItem('lang') == 'fr' ? 'Message' : 'الرسالة',
                         value: 'message',
                         align: 'center',
                         sortable: false
                    },
                    {
                         text: localStorage.getItem('lang') == 'fr' ? 'A été ouvert' : 'تم فتحها',
                         value: 'isShow',
                         align: 'center',
                         sortable: false
                    },
                    {
                         text: localStorage.getItem('lang') == 'fr' ? 'Date' : 'تاريخ الإرسال',
                         value: 'created_at',
                         align: 'center',
                         sortable: false
                    },
                    {
                         text: localStorage.getItem('lang') == 'fr' ? 'Action' : 'الحدث',
                         value: 'action',
                         align: 'center',
                         sortable: false
                    },
               ]
          }
     },
     methods: {
          init() {
               this.form = {
                    type: 1,
                    nom: '',
                    email: '',
                    sujet: '',
                    message: '',
                    reponse: '',
                    domainName: document.location.origin,
               }
          },
          updateResponse(data, index) {
               if (index == 1) {
                    this.form = data
                    this.form.type = 1
                    this.form.reponse = ''
                    this.form.sujet = '' 
                    this.dialog2 = true
               } else if (index == 2) {
                    this.details = data
                    this.dialog3 = true
               }
          },
          sendEmail() {
               this.loading = true
               var url = 'getMessage/sendMsg'
               var commit = 'getMessage'
               
               this.$Register({
                    data: JSON.stringify(this.form)
               }, url, commit).then((r) => {
                    this.loading = false
                    this.init()
                    this.dialog2 = false
               }).catch((ree) => {
                    this.loading = false
               })

          },
          removeItem(data) {
               this.$store.dispatch('deleteMessage', {
                    data: JSON.stringify(data)
               }) 
               this.$store.dispatch('getMessage')
          },
          deleteMulti() {
               this.$store.dispatch('deleteMessage', {
                    data: JSON.stringify(this.selected)
               }) 
               this.$store.dispatch('getMessage')
          },
          clirtext(e) {
               this.filters.created_at = ['', '']
          },
          close() {
               this.form.type = 0
               this.dialog2 = false
               this.dialog3 = false
          }
     },
     computed: {
          dateRangeText() {
               return this.filters.created_at.join(' ~ ')
          },
          message() {
               return new this.$MultiFilter(this.$store.state.message.filter(e => e.type == 0), this.filters).filterData()
          },
          message2() {
               return new this.$MultiFilter(this.$store.state.message.filter(e => e.type == 1), this.filters).filterData()
          },
      
          
     },
     created() {
          this.$store.dispatch('getMessage')
          this.$store.dispatch('getDemandes')
          this.init()
          Fire.$on('search', (search) => {
               this.search = search
          })
          Fire.$on('changeComponent2', idPage => {
               this.idPage = idPage
               if (idPage == 1) {
                    this.headers = [{
                              text: localStorage.getItem('lang') == 'fr' ? 'Nom' : 'الإسم',
                              value: 'nom',
                              align: 'center',
                              sortable: false
                         },
                         {
                              text: localStorage.getItem('lang') == 'fr' ? 'Email' : 'البريد الإلكلتروني',
                              value: 'email',
                              align: 'center',
                              sortable: false
                         },
                         {
                              text: localStorage.getItem('lang') == 'fr' ? 'Message' : 'الرسالة',
                              value: 'message',
                              align: 'center',
                              sortable: false
                         },
                         {
                              text: localStorage.getItem('lang') == 'fr' ? 'A été ouvert' : 'تم فتحها',
                              value: 'isShow',
                              align: 'center',
                              sortable: false
                         },
                         {
                              text: localStorage.getItem('lang') == 'fr' ? 'Date' : 'تاريخ الإرسال',
                              value: 'created_at',
                              align: 'center',
                              sortable: false
                         },
                         {
                              text: localStorage.getItem('lang') == 'fr' ? 'Action' : 'الحدث',
                              value: 'action',
                              align: 'center',
                              sortable: false
                         },
                    ]
               } else if (idPage == 2) {
                    this.headers = [{
                              text: localStorage.getItem('lang') == 'fr' ? 'Nom' : 'الإسم',
                              value: 'nom',
                              align: 'center',
                              sortable: false
                         },
                         {
                              text: localStorage.getItem('lang') == 'fr' ? 'Email' : 'البريد الإلكلتروني',
                              value: 'email',
                              align: 'center',
                              sortable: false
                         },
                         {
                              text: localStorage.getItem('lang') == 'fr' ? 'A été ouvert' : 'تم فتحها',
                              value: 'isShow',
                              align: 'center',
                              sortable: false
                         },
                         {
                              text: localStorage.getItem('lang') == 'fr' ? 'Date de réponse' : 'تاريخ الرد',
                              value: 'updated_at',
                              align: 'center',
                              sortable: false
                         },
                         {
                              text: localStorage.getItem('lang') == 'fr' ? 'Action' : 'الحدث',
                              value: 'action',
                              align: 'center',
                              sortable: false
                         },
                    ]
               }
          })
     }
}
</script>

<style scoped>
.btnIcon {
     background: transparent !important;
     cursor: pointer;
     margin-bottom: 20px;
}

.wangEditor-container .wangEditor-txt {
     color: #000 !important;
     min-height: 157px;
}
</style><style>
.v-application--is-ltr .v-textarea.v-text-field--enclosed .v-text-field__slot textarea {
     padding-right: 25px !important;
}
</style>
